import React from 'react';
import { X } from 'lucide-react';
import type { PermissionChangeEvent } from '../../services/websocket/websocket.service';

interface PermissionChangeNotificationProps {
  isOpen: boolean;
  event: PermissionChangeEvent | null;
  onClose: () => void;
}

export const PermissionChangeNotification: React.FC<PermissionChangeNotificationProps> = ({
  isOpen,
  event,
  onClose
}) => {
  if (!isOpen || !event) return null;

  const getTitle = () => {
    switch (event.action) {
      case 'REMOVED':
        return 'Permisos Removidos';
      case 'ADDED':
        return 'Nuevos Permisos';
      case 'UPDATED':
        return 'Permisos Actualizados';
      default:
        return 'Cambio de Permisos';
    }
  };

  const getBgColor = () => {
    switch (event.action) {
      case 'REMOVED':
        return 'bg-red-50 border-red-200';
      case 'ADDED':
        return 'bg-green-50 border-green-200';
      case 'UPDATED':
        return 'bg-blue-50 border-blue-200';
      default:
        return 'bg-gray-50 border-gray-200';
    }
  };

  return (
    <div className="fixed top-4 right-4 z-50 w-96 max-w-sm">
      <div className={`rounded-lg border-2 ${getBgColor()} shadow-lg overflow-hidden`}>
        <div className="p-4">
          <div className="flex items-start">
            <div className="w-full">
              <div className="flex items-center justify-between">
                <p className="text-sm font-medium text-gray-900">
                  {getTitle()}
                </p>
                <button
                  onClick={onClose}
                  className="inline-flex text-gray-400 hover:text-gray-500 focus:outline-none"
                >
                  <X className="h-5 w-5" />
                </button>
              </div>
              <p className="mt-1 text-sm text-gray-700">
                {event.details.message}
              </p>
              
              {/* Mensaje informativo */}
              <div className="mt-2 p-2 bg-gray-100 border border-gray-200 rounded text-xs text-gray-700">
                Tus permisos se han actualizado automáticamente. No necesitas cerrar sesión.
              </div>
              
              {/* Detalles específicos */}
              <div className="mt-2 text-xs text-gray-600">
                {event.details.roleName && (
                  <div><strong>Rol:</strong> {event.details.roleName}</div>
                )}
                {event.details.moduleName && (
                  <div><strong>Módulo:</strong> {event.details.moduleName}</div>
                )}
                {event.details.permissionName && (
                  <div><strong>Permiso:</strong> {event.details.permissionName}</div>
                )}
              </div>
            </div>
          </div>
        </div>
        
        {/* Barra de progreso para auto-cierre */}
        <div className="bg-gray-200 h-1">
          <div 
            className="h-1 bg-blue-500 transition-all ease-linear"
            style={{ 
              width: isOpen ? '0%' : '100%',
              transitionDuration: '10s'
            }}
          />
        </div>
      </div>
    </div>
  );
};